<div class="container" fxLayout="column" fxLayoutGap="20">
    <div fxLayout="row" class="image-container" fxlayoutalign="center center" alt="Brand Logo">
        <img mat-card-image src="{{logoUrl}}" alt="star image">
    </div>
    <div fxLayout="row" fxlayoutalign="center center">
        <div fxFlex="50" class="left-side">
            <div class="welcome-text">Welcome Smoothie King team member!</div>
            <div class="welcome-content"> You re just a few minutes away from opening a Texas
                Capital Bank Employee Benefit Banking account to start
                saving and getting access to great perks.</div>
            <div class="smoothie-image-container">
                <img mat-card-image src="{{smoothieKing}}" alt="smoothie king image">
            </div>
        </div>
        <div fxFlex="50" class="right-side">
            <div class="man-seating-image">
                <img mat-card-image src="{{manSeatingUrl}}" alt="man seating image">
            </div>

            <div class="headstar-image">
                <img mat-card-image src="{{headstarUrl}}" alt="man seating image">
            </div>
        </div>
       
    </div>

    <div fxLayout="column" class="checking-container" fxlayoutalign="center center" fxLayoutGap="20">
        <div>
            <div class="employee-title">Employee Benefit Banking Checking</div>
        </div>
        <div class="balance-text" fxlayoutalign="center center">
            <div>Enjoy a digital-first experience with no minimum balance requirements while you earn interest on your cash.</div>
        </div>
        <div fxLayout="row" class="ulli-style" fxlayoutalign="space-around center">
            <div fxFlex="40" class="ulli-space">
                <ul>
                    <li>No monthly service fees1</li>
                    <li>No minimum balance requirement</li>
                    <li>Fee-free access to 55,000+ ATMs</li>
                </ul>
            </div>
            <div fxFlex="40">
                <ul>
                    <li>Earn 0.50% APY2</li>
                    <li>Online and mobile banking with account alerts</li>
                    <li>FDIC Insurance protection</li>
                </ul>
            </div>
        </div>

        <div fxLayout="column" fxlayoutalign="center center">
            <div class="employee-title">
                <button class="open-account-button" (click)="openAccount(openAccountUrl1)">Open Account</button>
            </div>
        </div>
        <div fxLayout="column" fxlayoutalign="center center">
            <div class="view-product-rates">
                <a href="employee-benefit/products">View Product Rates</a>
            </div>
        </div>
    </div>

    <div fxLayout="column" class="checking-container saving-container" fxlayoutalign="center center" fxLayoutGap="20">
        <div>
            <div class="employee-title">Employee Benefit Banking Savings</div>
        </div>
        <div class="balance-text" fxlayoutalign="center center">
            <div>Earn a competitive interest rate with no monthly service charge while you save.</div>
        </div>
        <div fxLayout="row" class="ulli-style" fxlayoutalign="space-around center">
            <div fxFlex="40" class="ulli-space">
                <ul>
                    <li>$0 monthly service fee</li>
                    <li>No minimum balance requirement </li>
                    <li>$100 minimum opening balance </li>
                </ul>
            </div>
            <div fxFlex="40">
                <ul>
                    <li>Earn 2.02% APY2</li>
                    <li>Waived wire transfer fees </li>
                    <li>FDIC Insurance protection</li>
                </ul>
            </div>
        </div>

        <div fxLayout="column" fxlayoutalign="center center">
            <div class="employee-title">
                <button class="open-account-button" (click)="openAccount(openAccountUrl2)">Open Account</button>
            </div>
        </div>
        <div fxLayout="column" fxlayoutalign="center center">
            <div class="view-product-rates">
                <a href="employee-benefit/products">View Product Rates</a>
            </div>
        </div>
    </div>

    <div fxLayout="column" class="checking-container" fxlayoutalign="center center" fxLayoutGap="20">
        <div>
            <div class="employee-title">Employee Benefit Banking Money Market</div>
        </div>
        <div class="balance-text" fxlayoutalign="center center">
            <div>High-yield account that earns interest, and your funds remain accessible from your debit card.</div>
        </div>
        <div fxLayout="row" class="ulli-style" fxlayoutalign="space-around center">
            <div fxFlex="40" class="ulli-space">
                <ul>
                    <li> $0 monthly service fee</li>
                    <li>No minimum balance requirement </li>
                    <li>$100 minimum opening balance </li>
                </ul>
            </div>
            <div fxFlex="40">
                <ul>
                    <li> Earn 2.02% APY2</li>
                    <li>Waived wire transfer fees </li>
                    <li>FDIC Insurance protection</li>
                </ul>
            </div>
        </div>

        <div fxLayout="column" fxlayoutalign="center center">
            <div class="employee-title">
                <button class="open-account-button" (click)="openAccount(openAccountUrl3)">Open Account</button>
            </div>
        </div>
        <div fxLayout="column" fxlayoutalign="center center">
            <div class="view-product-rates">
                <a href="employee-benefit/products">View Product Rates</a>
            </div>
        </div>
    </div>

    <div fxLayout="column" class="monthly-service" fxLayoutAlign="space-between left" >
        <div class="monthly-content">1 $15 monthly service fee assessed if account does not receive recurring, monthly direct deposit of any
            amount.
        </div>

        <div>2 Rates on all checking and savings account types are for personal accounts only and are subject to change
            at any time without notice. Interest on checking accounts is
            compounded daily on the collected balance and paid monthly. For savings accounts, interest is compounded
            daily on the collected balance and paid quarterly. Current rates
            effective Monday, March 27, 2023.
        </div>
    </div>

      <div fxLayout="column" class="footer-content" fxlayoutalign="left left">
        <app-footer></app-footer>        
    </div>

</div>